import { LayoutComponent } from "@jelly/lesson";

import * as airborne from "./contributions/airborne";
import * as structureBorne from "./contributions/structure-borne";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controls: [
          {
            type: "button",
            options: {},
            items: [{ name: "Airborne" }, { name: "Structure borne" }],
          },
        ],
        controlsPosition: "bottom",
        extraContent: [airborne.extraContent, structureBorne.extraContent],
        components: [airborne.components, structureBorne.components],
      },
    },
  },
];

export default components;
